import { ajax } from "@/assets/js/ajax";

// 获取文件列表
export function getFileList(data) {
  return ajax({
    url: 'netdisk/index',
    type: 'get',
    data
  })
}

// 获取面包屑路径
export function getBreadApi(params) {
  return ajax({
    url: 'file/path',
    type: 'get',
    params
  })
}

//新建文件夹
export function createFolderApi(data) {
  return ajax({
    url: 'netdisk/createFolder',
    type: 'post',
    data
  })
}

//重命名
export function renameApi(data) {
  return ajax({
    url: 'netdisk/rename',
    type: 'post',
    data
  })
}

//上传
export function uploadFileApi(data) {
  return ajax({
    url: 'netdisk/upload',
    type: 'post',
    headers: { 'Content-Type':'multipart/form-data' },
    data
  })
}

//移动
export function fileMoveApi(data) {
  return ajax({
    url: 'netdisk/move',
    type: 'post',
    data
  })
}

//删除
export function fileDeleteApi(data) {
  return ajax({
    url: 'netdisk/delete',
    type: 'post',
    data
  })
}

//获取文件下载链接
export function filedownloadApi(data) {
  return ajax({
    url: 'netdisk/download',
    type: 'get',
    data
  })
}

//复制文件
export function fileCopyApi(data) {
  return ajax({
    url: 'netdisk/copy',
    type: 'post',
    data
  })
}
